import meterRegular from '@/static/data/document.meter.regular.json';
import meterMaas from '@/static/data/document.meter.maas.json';
import panels from '@/static/data/document.panels.json';
import tenant from '@/static/data/document.tenant.json';

import { DynamicDocumentGroup } from '@/types.js';

export default {
  ['METER-REGULAR']: meterRegular as DynamicDocumentGroup[],
  ['METER_MAAS-REGULAR']: meterMaas as DynamicDocumentGroup[],
  ['PANELS-REGULAR']: panels as DynamicDocumentGroup[],
  ['TENANT']: tenant as DynamicDocumentGroup[],
};
